export const PAGE_FIX_FORM_TAB_ICON = {
    info: 'fas fa-info-circle',
    options: 'fas fa-cog',
    testing: 'fas fa-vial',
} as const;
